"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RulesetHandler {
    constructor() {
        const defaults = {
            inMessage: false,
            inResult: false,
            result: [],
            currentResult: null,
            defaultMsg: '',
            currentRule: null,
        };
        this.init(defaults);
    }
    init(defaults) {
        Reflect.ownKeys(defaults).forEach(k => {
            this[k] = defaults[k];
        });
    }
    onopentag(name, attribs) {
        if (name === 'ruleSet') {
            this.currentRule = attribs.ID;
        }
        else if (name === 'result') {
            this.inResult = true;
        }
        else if (name === 'message') {
            this.inMessage = true;
        }
    }
    ontext(text) {
        if (this.inResult) {
            const result = text.trim();
            this.currentResult = { rulesetId: this.currentRule, result };
        }
        else if (this.inMessage) {
            this.currentResult.msg = text.trim();
        }
    }
    onclosetag(name) {
        if (name === 'rule') {
            this.currentRule = null;
            this.result = [...this.result, this.currentResult];
        }
        else if (name === 'result') {
            this.inResult = false;
        }
        else if (name === 'message') {
            this.inMessage = false;
        }
    }
    onend() {
        const addDefaultMsg = rules => rules.map(rule => (rule.msg ? rule : { ...rule, msg: this.defaultMsg }));
        this.result = addDefaultMsg(this.result);
    }
}
exports.default = RulesetHandler;
//# sourceMappingURL=ruleset-parser.js.map